import type {
  BuildSidebarRows,
  BuildSidebarRowsArgs,
  BuildSidebarRowsResult,
  SidebarRow,
  SidebarRowItem,
} from "./types";

export const buildSidebarRows: BuildSidebarRows = <
  Item extends SidebarRowItem,
>({
  sortedItems,
  folderRecords,
  openFolderId,
  isSearching,
}: BuildSidebarRowsArgs<Item>): BuildSidebarRowsResult<Item> => {
  const folderGroups = folderRecords.map((folder) => {
    const folderItems: Item[] = [];
    return { folder, folderItems };
  });

  const folderGroupByFolderId = new Map(
    folderGroups.map((folderGroup) => [folderGroup.folder.id, folderGroup]),
  );
  const rootItems: Item[] = [];

  for (const item of sortedItems) {
    const folderGroup =
      item.folderId === null
        ? undefined
        : folderGroupByFolderId.get(item.folderId);
    // A folderId with no loaded folder renders at the root.
    if (folderGroup === undefined) {
      rootItems.push(item);
      continue;
    }
    folderGroup.folderItems.push(item);
  }

  const visibleFolderGroups = isSearching
    ? folderGroups.filter((folderGroup) => folderGroup.folderItems.length > 0)
    : folderGroups;

  const rows: SidebarRow<Item>[] = [];
  const orderedItems: Item[] = [];

  for (const { folder, folderItems } of visibleFolderGroups) {
    const isOpen = isSearching || folder.id === openFolderId;
    rows.push({
      kind: "folder",
      folder,
      planCount: folderItems.length,
      isOpen,
    });
    folderItems.forEach((item, folderItemIndex) => {
      if (isOpen) {
        rows.push({
          kind: "plan",
          item,
          position: orderedItems.length,
          folderBranch:
            folderItemIndex === folderItems.length - 1 ? "last" : "middle",
        });
      }
      orderedItems.push(item);
    });
  }

  if (visibleFolderGroups.length > 0 && rootItems.length > 0) {
    rows.push({ kind: "rootDivider" });
  }

  for (const item of rootItems) {
    rows.push({
      kind: "plan",
      item,
      position: orderedItems.length,
      folderBranch: "none",
    });
    orderedItems.push(item);
  }

  return { rows, orderedItems };
};
